import React from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useConnectorState } from "../../provider/Connector";
import { useTranslations } from "../../utils/translations";
import { DashboardTileProps } from "./components/DashboardTile";

export const useFundraisingToolsDashboard = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('mobile'));
    const { routeUrls, givelithonEnabled, snapGiveEnabled } =
        useConnectorState();
    const copy = useTranslations('root', {
        onlineGiving: ['title', 'description'],
        socialMediaGiving: ['title', 'description'],
        givelithon: ['title', 'description'],
        snapGive: ['title', 'description'],
    });
    const navigate = useNavigate();

    const onTileClick = React.useCallback(
        (actionUrl: string) => {
            navigate(actionUrl);
        },
        [navigate],
    );

    const dashboardTiles = React.useMemo(() => {
        const result: DashboardTileProps[] = [
            {
                icon: 'gift-card',
                title: 'onlineGiving',
                description: 'onlineGiving',
                href: routeUrls.onlineGiving || '',
                onClick: () => onTileClick(routeUrls.onlineGiving || ''),
            },
            {
                icon: 'thumb-up',
                title: 'socialMediaGiving',
                description: 'socialMediaGiving',
                href: routeUrls.socialMediaGiving || '',
                onClick: () => onTileClick(routeUrls.socialMediaGiving || ''),
            },
        ];
        if (givelithonEnabled) {
            result.push({
                icon: 'star',
                title: 'givelithon',
                description: 'givelithon',
                href: routeUrls.givelithon || '',
                onClick: () => onTileClick(routeUrls.givelithon || ''),
            });
        }
    
        if (snapGiveEnabled) {
            result.push({
                icon: 'star',
                title: 'snapGive',
                description: 'snapGive',
                href: routeUrls.snapGive || '',
                onClick: () => onTileClick(routeUrls.snapGive || ''),
            });
        }
        return result.map((item) => ({
            ...item,
            title: copy[item.title].title,
            description: copy[item.title].description,
        }));
    }, [copy, routeUrls, givelithonEnabled, snapGiveEnabled, onTileClick]);

    return { dashboardTiles, isMobile } as const;
};